import React, {useState, useEffect} from 'react'
import Topbar from '../../components/landingTopbar'
import {useHistory} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'






import TextInputField from '../../components/inputText'
import LoadingButton from '../../components/loadingButton'
import {signinAction} from '../../actions'
import NotificationMessage from '../../components/notificationMessage';
import Accordions from '../../components/accordion';
import {validateToken, changePassword} from '../../actions'
import {REGISTRATION_LOADING_ID, SIGNIN_LOADING_ID} from '../../store/loaders'








const ResetPassword = ()=>{

    const history = useHistory()
    const dispatch = useDispatch()


    const [show, setShow] = useState(false);
    const [changeView, setChangeView] = useState(true)
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')





    const [phoneNumber, setPhoneNumber] = useState('')
    const [passwordError, setPasswordError] = useState('')
    const [phoneNumberError, setPhoneNumberError] = useState('')






    const [signinStatus,
        setSigninStatus] = useState('')

    const apiResponse = useSelector(state=>{
        const {signIn, loader,registration, membershipGrade, signinStatus, validateToken, changePassword} = state
        const {registered} = registration
        const {grades} = membershipGrade
        const {isLoading} = loader[REGISTRATION_LOADING_ID] || {isLoading: false}
        const signInLoader = loader[SIGNIN_LOADING_ID] || false
        const {currentUser} = signIn
        const {token} = validateToken
        const {status} = changePassword
        return{
            currentUser,
            isLoading,
            registered,
            grades,
            signInLoader: signInLoader.isLoading,
            status,
            token,
            status
        }
    })
    const actionLoader = apiResponse.isLoading
    const loginLoader = apiResponse.signInLoader

    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')





    useEffect(()=>{
        dispatch(validateToken(token))
    },[])


    useEffect(()=>{
        setSigninStatus(apiResponse.status?.description)
    },[apiResponse.status])

  
    const handlePassword = (data) =>{
        setPassword(data)
    }

    const handleConfirmPassword = (data) =>{
        setConfirmPassword(data)
    }


    const handleKeyPress = (e)=>{
        if(e.which === 13) {
            if(phoneNumber === ''){
                setPhoneNumberError('Username can not be empty')
                return 
            }
            if(password === '' || phoneNumber === ''){
                setPasswordError("Password can not be empty")
                return 
            }
            if(password !== '' && phoneNumber !== ''){
                dispatch(signinAction({
                    phoneNumber,
                    password
                }))
                sessionStorage.setItem('steps', true)
            }
          }
    }   

    const handleCloseNotificationMessage = ()=>{
        setSigninStatus('')
    }

    const handleChangePassword = () =>{
        if(password === confirmPassword){
            dispatch(changePassword({token: token, password}))
            return
        }
        console.log("we not good here")
    }
   

    return(
        <>
        <Topbar/>
        <div className="membership-container">
           <div className="membership-left-ctn">
               <div className="mb-4 d-flex" style={{flexDirection: 'column'}}>
                    <p>
                        Welcome to IER - Membership Platform
                    </p>
                    <span className="welcome-text">
                        The Institution of Engineers Rwanda(IER), started in 2008 as learned society of engineering profession with an aim to promote and develop engineering services and best practice for sustainable development of our country.
                        This was in line with government’s commitment to promote science and technology for the national development, while promoting the engineering profession leading to improved quality and efficiency of services. 
                    </span>
               </div>
            <Accordions/>
           </div>
           <div className="membership-right-ctn">
               <div className="login-ctn">
                  { signinStatus !== '' &&
                    <NotificationMessage
                        signinStatus={signinStatus}
                        handleCloseNotificationMessage={handleCloseNotificationMessage}/> }
                   <p>
                        Reset Password
                   </p>
                   <TextInputField
                        placeholder="New Password"
                        error={phoneNumberError}
                        handleChange={(e)=>handlePassword(e)}
                        onKeyPress={handleKeyPress}
                        isPassword={true}

                        />
                    <br/>
                   <TextInputField
                        placeholder="Confirm Password"
                        error={passwordError}
                        isPassword={true}
                        handleChange={(e)=>handleConfirmPassword(e)}
                        onKeyPress={handleKeyPress}/>
                    <div style={{ 
                        width: '70%', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        marginTop: 10
                        }}>
                        <LoadingButton
                            text="Reset"
                            handleLogin={handleChangePassword}
                            disabled={loginLoader}/>
                    </div>
               </div>
           </div>
        </div>
        </>
    )
}


export default ResetPassword 